var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBagColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88066 15.9722V20.8684C1.88066 21.8233 1.457 23.0024 1.21951 23.8506C1.16821 24.0318 1.08298 24.3446 1.0143 24.5978C0.953895 24.8179 1.09043 24.9966 1.31881 24.9966H21.4735C21.7019 24.9966 21.8385 24.8179 21.7781 24.5978C21.7094 24.3446 21.6233 24.031 21.5728 23.8506C21.3354 23.0024 20.9117 21.8233 20.9117 20.8684V15.9722C20.9125 10.9594 17.1086 6.79224 12.0958 6.79224H10.6982C5.68455 6.79224 1.88066 10.9594 1.88066 15.9722Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4757 24.9967C21.7041 24.9967 21.8406 24.818 21.7802 24.5979C21.7115 24.3447 21.6255 24.031 21.575 23.8507C21.3375 23.0025 20.9138 21.8233 20.9138 20.8684V15.9723C20.9138 12.2181 18.7798 8.93878 15.6023 7.52794C14.8667 7.32521 14.0938 7.20605 13.2845 7.20605H11.8869C6.87329 7.20605 3.07023 11.3732 3.07023 16.386V21.2822C3.07023 22.2371 2.64657 23.4162 2.40908 24.2644C2.35861 24.4423 2.27586 24.7468 2.20801 24.9975L21.4757 24.9967Z",
    fill: "#FCB701"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2229 6.7923H10.5679C10.5679 6.7923 7.3358 1 8.49923 1C9.66266 1 9.99778 1.82747 11.4202 1.82747C12.8426 1.82747 13.1273 1 14.2915 1C15.4558 1 12.2229 6.7923 12.2229 6.7923Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2235 6.7923H10.8979C10.8979 6.7923 8.94833 1.34506 10.2772 1.60736C10.6024 1.67191 10.9401 1.82747 11.4208 1.82747C12.8441 1.82747 13.1279 1 14.2921 1C15.4564 1 12.2235 6.7923 12.2235 6.7923Z",
    fill: "#FCB701"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7798 24.5978C21.7111 24.3446 21.6251 24.031 21.5746 23.8506C21.3371 23.0024 20.9134 21.8233 20.9134 20.8684V15.9722C20.9134 10.923 16.7827 6.79224 11.7335 6.79224H10.6983C10.594 6.79224 10.4931 6.80465 10.3896 6.80879C15.2477 6.97759 18.8977 11.0645 18.8977 15.9722V20.8626C18.8977 23.1497 17.0417 25.0032 14.7546 24.9999L12.8398 24.9966H21.4753C21.7037 24.9966 21.8402 24.8179 21.7798 24.5978Z",
    fill: "#FCB701"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26904 18.1402C9.37744 18.2842 10.2215 19.2043 11.3965 19.2043C12.5715 19.2043 13.5239 18.309 13.5239 17.0769C13.5239 15.6437 11.9062 15.1117 11.3965 14.9486C10.8868 14.7865 9.80028 14.2345 9.80028 13.3533C9.80028 12.472 10.5144 11.7571 11.3965 11.7571C11.9674 11.7571 12.67 12.0533 12.9927 12.2958",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.396 20.0318V19.2043",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.396 11.7572V10.9297",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2238 6.7923H10.5689C10.5689 6.7923 7.33678 1 8.50021 1C9.66363 1 9.99876 1.82747 11.4212 1.82747C12.8436 1.82747 13.1283 1 14.2925 1C15.4568 1 12.2238 6.7923 12.2238 6.7923Z",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37053 9.54275C2.81571 11.2076 1.88066 13.4857 1.88066 15.9722V20.8684C1.88066 21.8233 1.457 23.0024 1.21951 23.8506C1.16821 24.0318 1.08298 24.3446 1.0143 24.5978C0.953895 24.8179 1.09043 24.9966 1.31881 24.9966H21.4735C21.7019 24.9966 21.8385 24.8179 21.7781 24.5978C21.7094 24.3446 21.6233 24.031 21.5728 23.8506C21.3354 23.0024 20.9117 21.8233 20.9117 20.8684V15.9722C20.9125 10.9594 17.1086 6.79224 12.0958 6.79224H10.6982C8.90011 6.79224 7.25758 7.32761 5.89059 8.24693",
    stroke: "#07278A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagColor);
export default __webpack_public_path__ + "static/media/money-bag-color.a743b26877ac9895dd7f2d541c93c32f.svg";
export { ForwardRef as ReactComponent };